'use client';

import { FeatureFlag, useFeatureFlag } from '@/libs/feature-flags/client';
import { isGamificationAllowedByEnvironment } from '../utils/gamificationAvailability';

export const useIsGamificationEnabled = () => {
  const isFlagEnabled = useFeatureFlag(FeatureFlag.GAMIFICATION_ENABLED);

  return isGamificationAllowedByEnvironment() && isFlagEnabled;
};
